import React from 'react';
import { useFieldHelper, LinkField, FieldProps } from 'framework/ui/field';
import { useVendorsUrl } from 'domain/finance/vendors/routes';

interface InvoiceLinkProps extends FieldProps {
  nameSource: string;
}

const VendorLink = ({ source, nameSource, ...props }: InvoiceLinkProps) => {
  const { getValue } = useFieldHelper({ source });
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const { getSingleEntityUrl } = useVendorsUrl();
  const id = getValue();
  const name = getName();

  return <LinkField linkText={name || id} isInternal value={getSingleEntityUrl(id)} {...props} />;
};

export default VendorLink;
